import { render, staticRenderFns } from "./BalanceHistoryOperations.vue?vue&type=template&id=2b59ed6c&scoped=true"
import script from "./BalanceHistoryOperations.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryOperations.vue?vue&type=script&lang=js"
import style0 from "./BalanceHistoryOperations.vue?vue&type=style&index=0&id=2b59ed6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b59ed6c",
  null
  
)

export default component.exports